import React from 'react';
import Header from '../Heaader/Header';
import './Hero.css';
import hero_image from '../../assets/herorony1.png';
import hero_image_back from '../../assets/hero_image_back.png';
import Heart from '../../assets/heart.png';
import Calories from '../../assets/calories.png';
import { motion } from 'framer-motion';
import NumberCounter from 'number-counter';

const Hero = () => {
  const transition = { type: 'spring', duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <div className='hero'>
      <div className='blur blur-h'></div>
      <div className='left-h'>
        <Header />
        {/* the best ad div */}
        <div className='the-best-ad'>
          <motion.div
            initial={{ left: mobile ? '150px' : '238px' }}
            whileInView={{ left: '8px' }}
            transition={{ ...transition, type: 'tween' }}
          ></motion.div>
          <span>The best fitness club in town</span>
        </div>

        {/* hero heading */}
        <div className='hero-text'>
          <div>
            <span className='stroke-text'>SHAPE </span>
            <span>YOUR</span>
          </div>
          <div>
            <span> IDEAL BODY</span>
          </div>
          <div className='hero'>
            <span>
              Here we help you to build and shap your body and live your life to
              the fullest
            </span>
          </div>
        </div>

        {/* figures */}
        <div className='figures'>
          <div>
            <span>
              <NumberCounter end={10} start={0} delay='4' prefix='+' />
            </span>
            <span>expert coaches</span>
          </div>
          <div>
            <span>
              <NumberCounter end={300} start={50} delay='4' prefix='+' />
            </span>
            <span>members joined</span>
          </div>
          <div>
            <span>
              <NumberCounter
                end={18}
                start={10}
                delay='4'
                prefix='g'
                suffix='+'
              />
            </span>
            <span>fitness programs</span>
          </div>
        </div>

        {/* hero buttons */}
        <div className='hero-buttons'>
          <button className='btn'>Get Started</button>
          <button className='btn'>Learn more</button>
        </div>
      </div>
      <div className='right-h'>
        <button className='btn'>Join now</button>

        <motion.div
          className='heart-rate'
          initial={{ right: '-1rem' }}
          whileInView={{ right: '4rem' }}
          transition={transition}
        >
          <img src={Heart} alt='' />
          <span>Heart rate</span>
          <span>148 bpm</span>
        </motion.div>

        {/* hero images */}
        <img src={hero_image} alt='' className='hero_image' />
        <motion.img
          initial={{ right: '11rem' }}
          whileInView={{ right: '20rem' }}
          transition={transition}
          src={hero_image_back}
          alt=''
          className='hero_image_back'
        />

        {/* calories */}
        <motion.div
          className='calories'
          initial={{ right: '37rem' }}
          whileInView={{ right: '28rem' }}
          transition={transition}
        >
          <img src={Calories} alt='' />
          <div>
            <span>Calories Burned</span>
            <span>200 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
